import { Injectable } from '@angular/core';
import { Emails } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class EmailListService {
  public emailList: Emails[] = [];

  constructor() {}

  addEmail(email: any) {
    let id = this.emailList.length + 1;

    const item: Emails = {
      id: id,
      email: email,
    };
    this.emailList.unshift(item);
  }

  deleteEmail(item: any) {
    let index = this.emailList.indexOf(item);
    this.emailList.splice(index, 1);
  }
}
